export default "__VITE_ASSET__74cecbc0__"